import { Icon, IconProps } from ".";

export const Check = (props: IconProps) => {
  return (
    <Icon {...props} viewBox="0 0 49 49">
      <path d="M16.7765 37.0916L8.04883 28.364L10.9574 25.4554L16.7765 31.2745L37.1403 10.9087L40.0488 13.8192L16.7765 37.0916Z" />
    </Icon>
  );
};
